module.exports = __webpack_public_path__ + "static/media/dog-leashed.6e19afea.svg";